<template>
  <v-slide-y-transition mode="out-in">
    <v-container class=" pa-0 pb-4 fluid">      
      <v-layout column>
        <v-flex sm12>
          <explore-eks v-if="showFormEks"></explore-eks>                
        </v-flex>
      </v-layout>  
    </v-container>
  </v-slide-y-transition>
</template>
<script>
import ExploreEks from './explore-eks';


export default {
  components: {
    ExploreEks,
    
  },
  data () {
    return {
      //chat: null,
      //selectedTab: null,
    };
  },
  mounted(){
    if(!this.$route.query.kompetisi_id){
      this.$router.push({path:this.$route.path, query:{kompetisi_id : 3, mode:1}});
    }   
  },
  watch:{
    $route (to, from){
      if(!this.$route.query.kompetisi_id){
        this.$router.push({path:this.$route.path, query:{kompetisi_id : 3, mode:1}});
      }
    }
  },  
  computed: {
    showFormEks() {
      return this.$route.query.mode == 1;
    },            
  },
};
</script>

